/**
 * Axis label for an elapsed time given in HOURS.
 *
 * WHY THIS EXISTS. Every time axis in the app used `value.toFixed(0)}h`, which
 * is fine for a 24 or 48 hour valley routing and useless below one hour: the
 * first real DualSPHysics run is 300 seconds, and its flooded-area axis
 * rendered as nineteen consecutive "0h" labels. A near-field solver and a
 * valley routing share these charts, so the label has to carry three orders of
 * magnitude.
 *
 * Zero still reads "0h" so that long runs look exactly as they did before.
 */
export function formatElapsedHours(value: number): string {
  const seconds = value * 3600
  if (!Number.isFinite(value)) return ''
  if (Math.abs(seconds) < 1) return '0h'
  if (Math.abs(value) < 1 / 60) return `${Math.round(seconds)}s`
  if (Math.abs(value) < 1) return `${Math.round(seconds / 60)}m`
  return `${value.toFixed(0)}h`
}
